import { css } from 'lit';
import { designTokenFactory } from '../../../../utils/design-tokens.js';

const dt = designTokenFactory('selectcard');

export const hostStyles = css`
  :host {
    display: flex;
    flex-direction: column;
    gap: var(${dt('gap')});
  }
`;

export const filterStyles = css`
  .filters {
    display: flex;
    overflow-x: auto;
    gap: var(${dt('filters.gap')});
  }
`;

export default [hostStyles, filterStyles];
